import { Component, ViewChild } from '@angular/core';
import { AuthService } from '../auth.service';
import { AccountStatsService } from '../account-stats.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})

export class NavMenuComponent {
  isExpanded = false;
  toggleText = "Sign In";

  @ViewChild('cat') cat;

  constructor(
    public accountStats: AccountStatsService,
    public auth: AuthService) {
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  toggleSignInOut() {
    if (this.auth.authenticated) {
      this.auth.signOut();
    }
    else {
      this.auth.signIn();
    }
  }

  toggleCat() {
    this.cat.toggleCat();
  }
}



// WEBPACK FOOTER //
// ./src/app/nav-menu/nav-menu.component.ts